import { makeHttpRequest } from "@/shared";

import { mapRightsToServer } from "./mappers/mapRightsToServer.js";

export const editRights = async (employeeId, rights) => {
    const response = (
        await makeHttpRequest({
            url: `/human/employee/${employeeId}/update-rights`,
            method: "PUT",
            data: mapRightsToServer(rights),
        })
    ).data;

    return response;
};
